import styled from 'styled-components';

export const Container = styled.header`
  background-color: ${({ theme }) => theme.colors.background.white};
  width: 100%;
  max-width: 100%;
  height: 44px;
  border-bottom: 1px solid #cccbcc;

  position: sticky;
  top: 0;
  z-index: 9;

  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;

  padding-right: 36px;

  p,
  button {
    font-size: 16px;
    font-weight: 800;
  }

  span {
    white-space: nowrap;
  }

  .welcomeContainer {
    display: flex;
    gap: 64px;

    div {
      display: flex;
      gap: 16px;
    }
  }
`;

export const Button = styled.button`
  background: transparent;
  border: none;
  color: ${({ theme }) => theme.colors.orange.primary};
  transition: 0.2s filter;

  &:hover {
    filter: brightness(0.8);
  }
`;

export const SelectContainer = styled.div`
  padding: 4px 0;

  border: 1px solid #cccbcc;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.white};
`;

export const Select = styled.select`
  border: none;
  outline: none;
  width: 100%;

  padding: 0 4px;

  font-weight: 400;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.gray[500]};
`;
